module.exports = __webpack_public_path__ + "img/2ed22f6.png";